// @flow

const workInterval = millisecondsInterval => localState => {
  if (!localState.result) {
    return true;
  }

  const now = new Date();
  const { lastWorkTimestamp } = localState;
  const diff = now.getTime() - lastWorkTimestamp.getTime();

  if (diff > millisecondsInterval) {
    return true;
  }

  return false;
};

export default workInterval;



// WEBPACK FOOTER //
// ./src/redux/utils/work-interval.js